import Api from '@/base/api.typings';
import axiosConfiguration from '@/base/axios-configuration';

class ServicoService {
    async listarServicoGrupos(query: Api.App.Server.Servico.ListarServicoGrupos.Query): Promise<Api.App.Server.Servico.ListarServicoGrupos.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ListarServicoGrupos', { params: query }).then(e => e.data);
    }

    async salvarServicoGrupos(command: Api.App.Server.Servico.SalvarServicosGrupos.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Servico/SalvarServicosGrupos', command);
    }

    async listarServicosPorGrupoId(query: Api.App.Server.Servico.ListarServicosPorGrupoId.Query): Promise<Api.App.Server.Servico.ListarServicosPorGrupoId.Dto[]> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ListarServicosPorGrupoId', { params: query }).then(e => e.data);
    }

    async obterServicoDescricao(query: Api.App.Server.Servico.ObterServicoDescricao.Query): Promise<Api.App.Server.Servico.ObterServicoDescricao.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoDescricao', { params: query }).then(e => e.data);
    }

    async salvarServicoDescricao(command: Api.App.Server.Servico.SalvarServicoDescricao.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Servico/SalvarServicoDescricao', command);
    }

    async obterServicoGrupoDescricao(query: Api.App.Server.Servico.ObterServicoGrupoDescricao.Query): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoGrupoDescricao', { params: query }).then(e => e.data);
    }

    async obterServicoUpPlanoId(query: Api.App.Server.Servico.ObterServicoUpPlanoId.Query): Promise<number> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoUpPlanoId', { params: query }).then(e => e.data);
    }

    async obterServicoAlterarDadosEmpresaId(query: Api.App.Server.Servico.ObterServicoAlterarDadosEmpresaId.Query): Promise<number> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoAlterarDadosEmpresaId', { params: query }).then(e => e.data);
    }

    async obterServicoAlterarDadosFuncionarioId(query: Api.App.Server.Servico.ObterServicoAlterarDadosFuncionarioId.Query): Promise<number> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoAlterarDadosFuncionarioId', { params: query }).then(e => e.data);
    }

    async obterServicoAlterarDadosSocioId(query: Api.App.Server.Servico.ObterServicoAlterarDadosSocioId.Query): Promise<number> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Servico/ObterServicoAlterarDadosSocioId', { params: query }).then(e => e.data);
    }
}

export default new ServicoService();